<template>
  <el-select v-model="selectedId" :placeholder="placeholder" :clearable="clearable" :filterable="filterable" @change="selectChange">
    <el-option v-for="item in lists" :key="item.id+item.name" :label="item.name" :value="item.id" />
  </el-select>
</template>

<script>

export default {
  name: 'GradeSelector',
  props: {
    selected: {
      type: [Number, String],
      required: true,
      default: 0
    },
    url: {
      type: String,
      required: false,
      default: ''
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
    filterable: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    data: {
      type: Array,
      required: false,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      lists: []
    }
  },
  computed: {
    selectedId: {
      get() {
        return this.selected
      },
      set(val) {
        this.$emit('update:selected', val)
      }
    }
  },
  watch: {
    data(val) {
      this.lists = val
    }
  },
  created() {
    this.selectedId = this.selected
    if (this.url) {
      this.getList()
    } else {
      this.lists = this.data
    }
  },
  methods: {
    getList() {
      this.$http.getSingleSelect(this.url)
        .then(response => {
          // 销售数据
          this.lists = response.data
        }).catch(err => {
          console.log(err)
        })
    },
    selectChange(val) {
      this.$emit('updateSelect', val)
    }
  }

}
</script>

<style scoped>

</style>
